/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-02-03 12:00:00
 *
 *******************************************************/
//@flow

import _ from 'lodash';
import React from 'react';
// DONE
export const StepProgress = (props: Object) => {
  return (
    <div className="step-progress-container">
      <ul className="progressbar">
        {_.map([1, 2], value => {
          return (
            <li
              key={value}
              className={`${props.step >= value ? 'active' : ''} ${
                props.step === value ? 'activating' : ''
              }`}>
              {value}
            </li>
          );
        })}
      </ul>
    </div>
  );
};
